import { AfterContentInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redir',
  templateUrl: './redir.component.html',
  styleUrls: ['./redir.component.scss']
})
export class RedirComponent implements AfterContentInit {
  public url: string | null = null;
  public showManualRedirection: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
  }

  ngAfterContentInit(): void {

    this.url = this.activatedRoute.snapshot.queryParamMap.get('u');
    if (this.url.trim() === '') {
      this.router.navigate(['/']);
    } else {
      if (!this.url.startsWith('http://') && !this.url.startsWith('https://')) {
        this.url = 'https://' + this.url;
      }
      setTimeout(() => {
        window.location.href = this.url;
      }, 500);

      setTimeout(() => {
        this.showManualRedirection = true;
      }, 4000);
    }
  }
}
